import styled from 'styled-components';
import { devices } from '../../../styles/viewports';
import { IProgressProps } from '../../../types/progress';

export const ProgressView = styled.div<IProgressProps>`
  height: ${({ height }) => (height ? `${height}px` : '6px')};
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const ElapsedProgressView = styled.div<IProgressProps & { isProgressWithSteps: boolean }>`
  background-color: ${({ color }) => (color ? `var(--base-color-${color})` : 'var(--base-color-progress)')};
  flex: ${({ progress }) => progress};
  padding-left: ${({ isProgressWithSteps }) => (isProgressWithSteps ? '34px' : '0')};

  @media ${devices.mobile} {
    padding-left: ${({ isProgressWithSteps }) => (isProgressWithSteps ? '24px' : '0')};
  }
`;

export const PendingProgressView = styled.div<IProgressProps>`
  background-color: ${({ color }) => (color ? `var(--base-color-${color})` : 'var(--base-color-lightgrey)')};
  opacity: 0.5;
  flex: ${({ progress }) => progress};
`;

export const StepsWrapper = styled.div<IProgressProps>`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  font-family: var(--font-family-body);
  font-feature-settings: var(--font-feature-settings-body);
  text-transform: var(--text-transform-body);
  font-size: var(--font-size-body-1);
  font-weight: var(--font-weight-body-1);
  letter-spacing: var(--letter-spacing-body-1);
  line-height: var(--line-height-body-1);

  @media ${devices.mobile} {
    font-size: var(--font-size-body-2);
    font-weight: var(--font-weight-body-2);
    letter-spacing: var(--letter-spacing-body-2);
    line-height: var(--line-height-body-2);
  }
`;

export const StepWrapper = styled.div<{ isVisible: boolean; isActive: boolean }>`
  visibility: ${({ isVisible }) => (isVisible ? `visible` : 'hidden')};
  color: ${({ isActive }) => (isActive ? `var(--base-color-black)` : 'var(--base-color-midgrey)')};
`;
